<template>
  <tr class="even:bg-white odd:bg-gray-50 align-top">
    <td class="px-4 py-4 text-sm text-gray-900">
      {{ audience.name }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-900 whitespace-nowrap text-center">
      <AudienceListItemSourceSize :type="audience.model_type" :source="audience.model" />
    </td>
    <td class="px-4 py-4 text-sm text-gray-900 whitespace-nowrap text-left">
      <AudienceListItemSource :type="audience.model_type" :source="audience.model" />
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <span class="whitespace-nowrap">
        {{ createdAtShort }}
      </span>
      <p class="text-xs whitespace-nowrap">
        {{ createdAtFromNow }}
      </p>
    </td>
    <td class="px-4 py-4">
      <div class="flex space-x-2 items-center justify-end">
        <AudienceEditAction :audience="audience" :on-updated="handleOnUpdated" />
        <AudienceSyncAction v-if="!isGaUserList" :audience="audience" :on-synced="handleOnSynced" />
        <AudienceDeleteAction :audience="audience" :on-deleted="handleOnDeleted" />
      </div>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';
import AudienceListItemSource from './AudienceTableListItemSource.vue';
import AudienceListItemSourceSize from './AudienceTableListItemSourceSize.vue';
import AudienceEditAction from './AudienceEditAction.vue';
import AudienceSyncAction from './AudienceSyncAction.vue';
import AudienceDeleteAction from './AudienceDeleteAction.vue';

export default {
  components: {
    AudienceListItemSource,
    AudienceListItemSourceSize,
    AudienceEditAction,
    AudienceSyncAction,
    AudienceDeleteAction,
  },
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    createdAt() {
      return moment.utc(this.audience.created_at).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
    isGaUserList() {
      return this.audience.model_type === 'ga_user_list';
    },
  },
  methods: {
    handleOnUpdated(updatedAudience) {
      this.$emit('audience-updated', updatedAudience);
    },
    handleOnSynced(syncedAudience) {
      this.$emit('audience-synced', syncedAudience);
    },
    handleOnDeleted() {
      this.$emit('audience-deleted');
    },
  },
};
</script>
